<template>
  <div class="col-md-12 no-padder" v-html="activity.html_content">
  </div>
</template>

<script>
export default {
  props: ['activity'],
  mounted() {
    console.log(this.activity)
  },
}
</script>

<style scoped>
@media only screen and (min-width: 1200px) {
}
@media only screen and (max-width: 1199px) and (min-width: 1024px) {
}
@media only screen and (max-width: 1023px) and (min-width: 768px) {
}
@media only screen and (max-width: 767px) {
}
</style>


